"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTenantLanguages = void 0;
var _fetching = require("@ori/fetching");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _react = require("react");
/* istanbul ignore file */

/**
 * React hook for getting languages for provided tenant
 */
const useTenantLanguages = (baseUrl, tenant, disabled) => {
  // We create api client by ourselves, because we do not need any context for this simple app
  const apiClient = (0, _react.useMemo)(() => new _staticApiClientReact.ApiClient({
    baseUrl,
    tenant
  }), [baseUrl, tenant]);
  const fetcher = (0, _react.useCallback)(async ([incomingTenant]) => {
    const {
      data: {
        languages
      }
    } = await (0, _staticApiClientReact.getTenantLanguages)(apiClient, incomingTenant);

    // It may happen that languages are an object instead of plain array
    return Object.values(languages);
  }, [apiClient]);
  return (0, _fetching.useSWR)([tenant, 'languages'], fetcher, {
    isPaused: () => !!disabled,
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
};
exports.useTenantLanguages = useTenantLanguages;